import { Container, Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import Image from 'next/image';
import Link from '../../../components/Link';

const useStyles = makeStyles()((theme) => ({
  cardInfo: {
    padding: '2em',
    zIndex: 1,
    position: 'relative',
    backgroundColor: 'white',
    borderRadius: '0.5em',
    width: '80%!important',
    alignItems: 'center',
    marginTop: '-53px',
    boxShadow: '0px 0px 38px -14px rgba(0, 0, 0, 0.46)',
    [theme.breakpoints.down('md')]: {
      marginLeft: '0',
      marginRight: '0',
      width: '100%!important',
      marginTop: '2em',
    },
  },
  align: {
    textAlign: 'center',
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    textAlign: 'center',
    marginTop: '2em',
  },
  gridItem: {
    backgroundColor: '#f9f9f9',
    margin: '12px',
    padding: '10px',
  },
  imageGrid: {
    paddingTop: '30px',
    paddingBottom: '20px',
  },
  buttonGrid: {
    fontSize: '1.2em',
    margin: '1.5em 0 1.5em 0 ',
    color: 'white',
    backgroundColor: '#2C367E',
    border: 'none',
    fontWeight: 'bold',
    borderRadius: '1.5em',
    padding: '0.2em 3em 0.2em 3em',
    minHeight: '2.5em',
    '&:hover': {
      cursor: 'pointer',
      color: '#2C367E',
      backgroundColor: 'white',
      border: '2px solid #2C367E',
      backgroundImage: "url('/arrow-hover.svg')",
      backgroundPositionX: '5px',
      backgroundPositionY: 'center',
    },
    backgroundImage: "url('/arrow.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: '5px',
    backgroundPositionY: 'center',
  },
  buttonGridDiv: {
    textAlign: 'center',
  },
  buttonInverseActor: {
    fontSize: '1.2em',
    margin: '1.5em 0 1.5em 0 ',
    fontWeight: 'bold',
    borderRadius: '1.5em',
    padding: '0.2em 3em 0.2em 3em',
    minHeight: '2.5em',
    color: '#68b5a9',
    backgroundColor: 'white',
    border: '2px solid #68b5a9',
    '&:hover': {
      cursor: 'pointer',
      color: 'white',
      backgroundColor: '#68b5a9',
      border: 'none',
      backgroundImage: "url('/arrow-hover-inverse.svg')",
      backgroundPositionX: '5px',
      backgroundPositionY: 'center',
      backgroundSize: '14%',
    },
    backgroundImage: "url('/arrow-actor.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: '5px',
    backgroundPositionY: 'center',
    backgroundSize: '14%',
  },
  buttonInverseOrganisation: {
    fontSize: '1.2em',
    margin: '1.5em 0 1.5em 0 ',
    fontWeight: 'bold',
    borderRadius: '1.5em',
    padding: '0.2em 3em 0.2em 3em',
    minHeight: '2.5em',
    color: '#d96552',
    backgroundColor: 'white',
    border: '2px solid #d96552',
    '&:hover': {
      cursor: 'pointer',
      color: 'white',
      backgroundColor: '#d96552',
      border: 'none',
      backgroundImage: "url('/arrow-hover-inverse.svg')",
      backgroundPositionX: '5px',
      backgroundPositionY: 'center',
      backgroundSize: '14%',
    },
    backgroundImage: "url('/arrow-organisation.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: '5px',
    backgroundPositionY: 'center',
    backgroundSize: '14%',
  },
  titleGrid: {
    fontSize: '1.3em',
    lineHeight: 'inherit',
    fontWeight: '600',
  },
  topIntroBlock: {
    maxWidth: '560px',
    margin: '0 auto',
  },
  flexColumn: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
}));

interface ThreepointProps {
  id?: string;
}

const PresentationSection = ({ id }: ThreepointProps) => {
  const { classes: styles } = useStyles();

  return (
    <Container maxWidth="xl" className={styles.cardInfo} id={id}>
      <Grid container spacing={3} className={styles.flexColumn}>
        <Grid item md={6}>
          <div className={styles.topIntroBlock}>
            <Typography className={styles.root}>
              Retrouve la présentation complète du projet OUAAA! sur la page{' '}
              <Link href="/about">Qui sommes-nous ?</Link>.
            </Typography>
            <div className={styles.buttonGridDiv}>
              <Link href="/map">
                <button className={styles.buttonGrid}>VOIR LA CARTE</button>
              </Link>
            </div>
          </div>
        </Grid>
        <Grid item md={6} className={styles.align} style={{ width: '100%' }}>
          <div
            className={styles.align}
            style={{ width: '100%', height: '100%', position: 'relative', minHeight: '300px' }}
          >
            <Image
              alt="Accueil OUAAA!"
              fill
              style={{ objectFit: 'contain' }}
              src="/image_accueil.png"
            />
          </div>
        </Grid>
      </Grid>
      <br />
      <Grid container justifyContent="center" className={styles.flexColumn}>
        <Grid item md={5} sm={10} className={`${styles.gridItem} ${styles.align}`}>
          <img width="30%" src="./Icone_decouvrir_acteur.png" className={styles.imageGrid} alt="" />
          <Typography className={styles.titleGrid}>
            Tu es un citoyen et souhaites mieux
          </Typography>
          <Typography className={styles.titleGrid}>connaître, soutenir, t'engager ?</Typography>
          <Link href="/map">
            <button className={styles.buttonInverseActor}>JE DÉCOUVRE LES ACTEURS</button>
          </Link>
        </Grid>
        <Grid item md={5} sm={10} className={`${styles.gridItem} ${styles.align}`}>
          <img width="30%" className={styles.imageGrid} src="./Icone_acteur.png" alt="" />
          <Typography className={styles.titleGrid}>
            Vous êtes une organisation et vous
          </Typography>
          <Typography className={styles.titleGrid}>souhaitez vous faire connaître ?</Typography>
          <Link href="/addactor">
            <button className={styles.buttonInverseOrganisation}>JE DEVIENS UN ACTEUR</button>
          </Link>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PresentationSection;
